<template>
  <div v-if="bankaccount">
    <edit-bank-account-form
      :is-active.sync="isEditing"
      :bankaccount="bankaccount"
      @edited="accountEdited"
    />
    <v-card-text>
      <v-row>
        <v-col cols="3">
          <key-value title="Id">
            <span class="small" v-text="bankaccount.id"></span>
          </key-value>
          <key-value title="Title" :value="bankaccount.title" />
          <key-value title="Owner Name" :value="bankaccount.owner_name" />
        </v-col>
        <v-col cols="3">
          <key-value title="Bank Name" :value="bankaccount.bank_name" type="none" />
          <key-value title="Country" :value="bankaccount.country" />
        </v-col>

        <v-col cols="3">
          <key-value title="Iban code" :value="bankaccount.iban" />
          <key-value title="Bic" :value="bankaccount.bic" />
        </v-col>
        <v-col cols="3">
          <h3>Actions</h3>
          <div>
            <v-btn color="primary" class="my-4" @click="isEditing = true" v-on="on">
              <v-icon>mdi-account-edit-outline</v-icon>
              Edit Account
            </v-btn>
            <v-btn color="danger" class="my-4" @click="deleteAccount" v-on="on">
              <v-icon>mdi-account-edit-outline</v-icon>
              Delete Account
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>
<script>
import EditBankAccountForm from "./editBankAccountForm";
export default {
  components: { EditBankAccountForm },
  props: {
    bankaccount: { required: true },
  },
  data() {
    return {
      isEditing: false,
    };
  },
  methods: {
    async deleteAccount() {
      const id = this.bankaccount.id;
      await Notify.confirm(`Please Confirm to delete the bank account`).then(() => {
        this.$http
          .delete(`/api/v1/userBankAccounts/${id}`)
          .then((result) => {
            Notify.success(result.message);
            this.$router.back();
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error) => {
            Notify.error(error.message);
          });
      });
    },
    accountEdited({ account }) {
      this.isEditing = false;

      this.$emit("update:account", account);
      Notify.success("Bank Account was updated successfully");
    },
  },
};
</script>
